import { create } from 'zustand'

import { FILTER_DEFAULT_SKIP, FILTER_DEFAULT_TAKE } from '@apps-common/config/filter'

export interface IUnitActivationFilter {
  searchVal: string
  setSearchVal: (value: string) => void
  statusVal: string
  setStatusVal: (value: string) => void
  take: number
  setTake: (value: number) => void
  skip: number
  setSkip: (value: number) => void
  clear: () => void
  isFiltered: () => boolean
  getFilteredByKeywords: () => string[]
}

export const useUnitActivationFilter = create<IUnitActivationFilter>((set, get) => ({
  searchVal: '',
  setSearchVal: (value: string) => set({ searchVal: value }),
  statusVal: '',
  setStatusVal: (value) => set({ statusVal: value }),
  take: FILTER_DEFAULT_TAKE,
  setTake: (value: number) => set({ take: value }),
  skip: FILTER_DEFAULT_SKIP,
  setSkip: (value: number) => set({ skip: value }),
  clear: () => set({ searchVal: '', statusVal: '', take: FILTER_DEFAULT_TAKE, skip: FILTER_DEFAULT_SKIP }),
  isFiltered: () => {
    const { searchVal, statusVal, take, skip } = get()

    return searchVal?.length > 0 || statusVal?.length > 0 || take !== FILTER_DEFAULT_TAKE || skip !== FILTER_DEFAULT_SKIP
  },
  getFilteredByKeywords: () => {
    const { searchVal, statusVal } = get()
    const keywords = []

    if (searchVal !== '') {
      keywords.push('Search')
    }

    if (statusVal !== '') {
      keywords.push('Status')
    }

    return keywords
  }
}))
